import React, { useEffect, useState } from 'react';
import { Text, Button, Card, Layout, Input, Select, Modal } from '@ui-kitten/components';
import { StyleSheet, View, Platform, ScrollView } from 'react-native';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { M_UPDATE_CAMPAIGN } from './../../data/api/mutation/m_campaigns';
import { Q_GET_CAMPAIGN } from '../../data/api/query/q_campaigns';
import { PageLoadingIndicator, LoadingIndicator, ModalLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';
import { Q_GET_SURVEY } from '../../data/api/query/q_survey';
import { M_UPDATE_BASIC_SURVEY } from '../../data/api/mutation/m_surveys';
import { AuthContext } from '../../App';
import { BasicCard, ListHeader } from '../../components/_primatives';


const useInputChanges = (initialValue = '') => {
    const [value, setValue] = React.useState(initialValue);
    return {
        value,
        onChangeText: setValue,
    };
};


export default function EditSurveyScreen({ navigation, route }) {
    const params = route?.params;
    console.log({ navigation, route, params });
    
    const { user } = React.useContext(AuthContext);
    const { pageSpacerHorizontal, isMediumScreenOrLarger, bodyWidth } = useScreenDimensions();
    const [surveyLoaded, setSurveyLoaded] = useState(false);
    const titleInput = useInputChanges();
    const descInput = useInputChanges();
    const instructionsInput = useInputChanges();
    const [modalVisible, setModalVisible] = React.useState(false);
    const [updateSurvey, { data, loading, error }] = useMutation(M_UPDATE_BASIC_SURVEY);
    const surveyResponse = useQuery(Q_GET_SURVEY, {
        variables: { survey_id: params.id },
        fetchPolicy: 'network-only'
    });
    useEffect(() => {
        if (surveyLoaded === false) {      
            const survey: any = (surveyResponse?.data?.surveys) ? surveyResponse.data.surveys[0] : undefined;
            console.log('useHook survey = ', survey);
            if (survey) {
                titleInput.onChangeText(survey.title);
                descInput.onChangeText(survey.description);
                instructionsInput.onChangeText(survey.instructions);
                setSurveyLoaded(true);
            }
        }
    });



    if (surveyResponse.loading) return  <PageLoadingIndicator />;
    if (surveyResponse.error) return <Text>Error :(</Text>;
    console.log('we have data, ', surveyResponse.data, titleInput, descInput);





    const onSubmit = async () => {
        setModalVisible(true);
        const newParams: any = {
            survey_id: params.survey_id,
            title: titleInput.value,
            description: descInput.value,
            instructions: instructionsInput.value
        };
        if (user && user.product_plan && user.product_plan.id > 1) {
            console.log('using prem or plat functionality');
            // newParams.campaign_id = selectedOption.value;
            // newParams.is_public = isPublic;
            // newParams.is_open = isOpen;
            // newParams.start_date = startDateInput.rawDate.toISOString();
            // newParams.end_date = endDateInput.rawDate.toISOString();
        }
        console.log(newParams, user);
        const updateSurveyResponse: any = await updateSurvey({ variables: newParams});
        console.log('updateSurvey', updateSurveyResponse);
        navigation.goBack();
    }

    if (loading) {
        return (
            <PageLoadingIndicator />
        );
    }
    if (error) {
        console.log(`ERROR: const [updateCampaign, { data, loading, error }] = useMutation(M_UPDATE_CAMPAIGN);`, error)
        return (
            <>
                <Text>{'There was an error with the request'}</Text>
            </>
        );
    }
    if (data) {
        console.log(`const [{ data }] = useMutation(M_UPDATE_CAMPAIGN);`, data)
    }

    const _renderHeader = () => (
        <ListHeader
            title={'Edit'}
            isMediumScreenOrLarger={isMediumScreenOrLarger}
            style={{ paddingHorizontal: 0, marginBottom: 20 }}
        />
    );
    const _renderFooter = () => (
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginVertical: 30}}>
            <Button style={styles.footerControl} status='basic' onPress={() => navigation.goBack()}>{'Cancel'}</Button>
            <Button onPress={onSubmit}>{'Save'}</Button>
        </View>
    );

    return (
        <Layout level='1' style={{ flex: 1 }}>       
            <ScrollView
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : {paddingHorizontal: pageSpacerHorizontal}}
            >
                <BasicCard style={{ borderWidth: 0 }}>
                    { _renderHeader() }
                    <Input
                        style={styles.input}
                        size='large'
                        placeholder='Survey Title'
                        label='Survey Title'
                        {...titleInput}
                    />
                    <Input
                        style={styles.input}
                        size='large'
                        placeholder='Survey Description'
                        label='Survey Description'
                        {...descInput}
                    />
                    <Input
                        style={styles.input}
                        size='large'
                        placeholder='Survey Instructions'
                        label='Survey Instructions (optional)'
                        {...instructionsInput}
                    />
                    { _renderFooter() }
                </BasicCard>
                <ModalLoadingIndicator modalVisible={modalVisible} />
            </ScrollView>
        </Layout>
    );

}


const styles = StyleSheet.create({
    input: {
        marginVertical: 10,
    },
    footerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: 10,
        marginRight: 10,
    },
    footerControl: {
        // marginTop: 5,
        // marginBottom: 5,
        // paddingLeft: 10
    },
});